import { __assign, __extends } from "tslib";
import React from 'react';
import { connect } from "react-redux";
import { View } from "react-native";
import * as Actions from "../../redux/actions/actions.js";
import { bindActionCreators } from "redux";
import { PnmacPaper, PnmacParagraph, PnmacTable, PnmacMediaQuery, PnmacRow, PnmacRowHeader, PnmacRadioButton, PnmacUIButton, PnmacMeta } from 'pnmac-universal-components';
import Tooltip from '@material-ui/core/Tooltip';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import { UPDATE_LOAN_PREF } from "../../redux/actions/actions.js";
import styles from '../../styles/styles.js';
import { SuccessMessage } from '../../components/SuccessMessage.js';
import { TrackerHitTypeLID_ENUM, TrackerActionLID_ENUM, TrackerCategoryLID_ENUM, UserLanguage_ENUM } from '../../redux/events/events.js';
import { textStyle } from "../../v2/theme";
import PnmacToolTip from "../../ToolTip";
import PnmacText from "../../Typography/PnmacText";
import HtmlToNative from '../../HtmlToNative/index.js';
var styles4 = {
  container: {
    flex: 1,
    padding: 16,
    paddingTop: 30,
    backgroundColor: '#fff'
  },
  head: {
    borderRadius: 10,
    height: "auto",
    minHeight: 40,
    backgroundColor: '#d6ddeb'
  },
  text: __assign({
    margin: 6
  }, textStyle.defaultTextDescription),
  color: "#003087",
  textHead: __assign({
    margin: 6
  }, textStyle.defaultTextTitle),
  row: {
    flexDirection: 'row',
    backgroundColor: '#FFF1C1'
  },
  btn: {
    width: 58,
    height: 18,
    backgroundColor: '#78B7BB',
    borderRadius: 2
  },
  btnText: {
    textAlign: 'center',
    color: '#fff'
  }
};
var PaperlessPreferences = /** @class */function (_super) {
  __extends(PaperlessPreferences, _super);
  function PaperlessPreferences(props) {
    var _this = _super.call(this, props) || this;
    _this.updateMessageCenter = function (value, property) {
      var loanPreference = _this.state.loanPreference;
      var index = loanPreference === null || loanPreference === void 0 ? void 0 : loanPreference.findIndex(function (s) {
        return parseInt(s.preferenceTypeCode) == parseInt(value);
      });
      if (index > -1) {
        loanPreference[index].changed = true;
        loanPreference[index].preferenceCode = property;
      } else {
        var l = __assign({}, loanPreference[0]);
        l.preferenceCode = property;
        l.preferenceTypeCode = value;
        l.changed = true;
        loanPreference.push(l);
      }
      _this.setState({
        loanPreference: loanPreference,
        notchanged: false
      }, function () {
        return _this.props.dispatch({
          type: UPDATE_LOAN_PREF,
          selectedLoanPreference: loanPreference
        });
      });
    };
    _this.status = function (check, type) {
      return type == check ? "checked" : "unchecked";
    };
    _this.setOnlineDefault = function () {
      _this.updateMessageCenter(300012, 300027);
      return "checked";
    };
    _this.state = {
      loanPreference: props.layout.selectedLoanPreference,
      confirmFinal: false,
      loading: false,
      notchanged: true
    };
    return _this;
  }
  PaperlessPreferences.getDerivedStateFromProps = function (props, state) {
    var _a;
    if (props.layout.selectedLoanPreference != state.loanPreference) {
      return __assign(__assign({}, state), {
        loanPreference: (_a = props.layout) === null || _a === void 0 ? void 0 : _a.selectedLoanPreference
      });
    } else {
      return null;
    }
  };
  PaperlessPreferences.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      layout = _a.layout,
      translations = _a.translations;
    var selectedLoanNumber = layout.selectedLoanNumber;
    var _b = this.state,
      loanPreference = _b.loanPreference,
      notchanged = _b.notchanged,
      loading = _b.loading,
      confirmFinal = _b.confirmFinal;
    var monthlyState = (loanPreference === null || loanPreference === void 0 ? void 0 : loanPreference.find(function (s) {
      return s.preferenceTypeCode == 300009;
    })) || {};
    var yearlyState = (loanPreference === null || loanPreference === void 0 ? void 0 : loanPreference.find(function (s) {
      return s.preferenceTypeCode == 300010;
    })) || {};
    var servicingCommunication = (loanPreference === null || loanPreference === void 0 ? void 0 : loanPreference.find(function (s) {
      return s.preferenceTypeCode == 300012;
    })) || {};
    var tableHead = ['', translations.OnlineOnly, translations.OnlineMail];
    var tableData = [[/*#__PURE__*/React.createElement(View, {
      style: {
        paddingRight: 10
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription
    }, translations.MonthlyStatementDelivery)), /*#__PURE__*/React.createElement(PnmacRadioButton, {
      idTag1: 'monthlyStatementOnlineOnly',
      status: this.status(monthlyState === null || monthlyState === void 0 ? void 0 : monthlyState.preferenceCode, 300027),
      onPress: function () {
        return _this.updateMessageCenter(300009, 300027);
      }
    }), /*#__PURE__*/React.createElement(PnmacRadioButton, {
      idTag1: 'monthlyStatementOnlineMail',
      status: Object.keys(monthlyState || {}).length == 0 ? "checked" : this.status(monthlyState === null || monthlyState === void 0 ? void 0 : monthlyState.preferenceCode, 300025),
      onPress: function () {
        return _this.updateMessageCenter(300009, 300025);
      }
    })], [/*#__PURE__*/React.createElement(View, {
      style: {
        paddingRight: 10
      }
    }, /*#__PURE__*/React.createElement(PnmacText, {
      style: textStyle.defaultTextDescription
    }, translations.YearEndStatementDelivery)), /*#__PURE__*/React.createElement(PnmacRadioButton, {
      idTag1: 'yearlyStatementOnlineOnly',
      status: this.status(yearlyState === null || yearlyState === void 0 ? void 0 : yearlyState.preferenceCode, 300027),
      onPress: function () {
        return _this.updateMessageCenter(300010, 300027);
      }
    }), /*#__PURE__*/React.createElement(PnmacRadioButton, {
      idTag1: 'yearlyStatementOnlineMail',
      status: Object.keys(yearlyState || {}).length == 0 ? "checked" : this.status(yearlyState === null || yearlyState === void 0 ? void 0 : yearlyState.preferenceCode, 300025),
      onPress: function () {
        return _this.updateMessageCenter(300010, 300025);
      }
    })], [/*#__PURE__*/React.createElement(View, {
      style: {
        paddingRight: 10
      }
    }, /*#__PURE__*/React.createElement(PnmacToolTip, {
      text: translations.OtherServicingCommunications,
      title: /*#__PURE__*/React.createElement("div", {
        style: __assign(__assign({}, textStyle.defaultTextDescription), {
          color: 'white'
        })
      }, /*#__PURE__*/React.createElement("div", null, "Some examples of servicing communications are:"), /*#__PURE__*/React.createElement("ul", {
        style: __assign(__assign({}, textStyle.defaultTextDescription), {
          color: 'white'
        })
      }, /*#__PURE__*/React.createElement("li", null, "Escrow Notices"), /*#__PURE__*/React.createElement("li", null, "ARM Notices"), /*#__PURE__*/React.createElement("li", null, "Privacy"), /*#__PURE__*/React.createElement("li", null, "Delinquent Notices"), /*#__PURE__*/React.createElement("li", null, "ACH Communications"), /*#__PURE__*/React.createElement("li", null, "Customer Service Notices"), /*#__PURE__*/React.createElement("li", null, "Account Change Notices")))
    })), /*#__PURE__*/React.createElement(PnmacRadioButton, {
      idTag1: 'servCommunicationOnlineOnly',
      status: Object.keys(servicingCommunication || {}).length == 0 ? this.setOnlineDefault() : this.status(servicingCommunication === null || servicingCommunication === void 0 ? void 0 : servicingCommunication.preferenceCode, 300027),
      onPress: function () {
        return _this.updateMessageCenter(300012, 300027);
      }
    }), /*#__PURE__*/React.createElement(PnmacRadioButton, {
      idTag1: 'servCommunicationOnlineMail',
      status: this.status(servicingCommunication === null || servicingCommunication === void 0 ? void 0 : servicingCommunication.preferenceCode, 300025),
      onPress: function () {
        return _this.updateMessageCenter(300012, 300025);
      }
    })]];
    return /*#__PURE__*/React.createElement(PnmacMediaQuery, {
      queries: {
        small: "(max-width: 599px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        mediumLarge: "(min-width: 1024px) and (max-width: 1199px)",
        large: "(min-width: 1200px)"
      }
    }, function (matches) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(PnmacMeta, {
        title: "Paperless Preferences"
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          justifyContent: "center"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          width: "100%"
        }
      }, confirmFinal ? /*#__PURE__*/React.createElement(SuccessMessage, {
        onClick: function () {
          return _this.setState({
            confirmFinal: false
          });
        },
        message: translations.PaperlessPreferenceSuccessMessage
      }) : null, /*#__PURE__*/React.createElement(PnmacRowHeader, {
        rowHeaderContainerStyles: __assign({}, styles.accountSettings.titleContainer),
        item: translations.PaperlessPreferences
      }), /*#__PURE__*/React.createElement(PnmacPaper, {
        containerStyles: {
          padding: 25,
          marginBottom: 20,
          borderBottomLeftRadius: 10,
          borderBottomRightRadius: 10,
          backgroundColor: "#FFF",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          boxShadow: "rgba(0, 0, 0, 0.08) 2px 4px 12px",
          elevation: 1,
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement(PnmacTable, {
        style: {
          width: "100%"
        },
        borderStyle: {
          borderColor: 'transparent'
        }
      }, /*#__PURE__*/React.createElement(PnmacRow, {
        flexArr: matches.small ? [2, 1, 1] : [4, 1, 1, 1],
        data: tableHead,
        style: styles4.head,
        textStyle: styles4.textHead
      }), tableData.map(function (rowData, index) {
        return /*#__PURE__*/React.createElement(PnmacRow, {
          key: index,
          flexArr: matches.small ? [2, 1, 1] : [4, 1, 1, 1],
          data: rowData,
          style: {
            marginLeft: 10
          },
          textStyle: styles4.text
        });
      })), /*#__PURE__*/React.createElement(HtmlToNative, {
        value: translations.PaperSuppressionGovernedMessage
      })), /*#__PURE__*/React.createElement("div", {
        style: styles.accountSettings.buttonContainer
      }, /*#__PURE__*/React.createElement(PnmacUIButton, {
        mode: 'contained',
        idTag1: 'btnLanguagePreferenceChange',
        loading: _this.state.loading,
        disabled: notchanged,
        onPress: function () {
          if (parseInt(selectedLoanNumber) > 0) {
            _this.setState({
              loading: true
            });
            var loanPrefs = loanPreference.filter(function (s) {
              return parseFloat(s.loanId) === parseFloat(selectedLoanNumber) && (s.preferenceTypeCode === 300009 || s.preferenceTypeCode === 300010 || s.preferenceTypeCode === 300012);
            });
            fetch("/api/loan/update_loan_preferences", {
              method: 'POST',
              headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": "Bearer ".concat(_this.props.layout.token)
              },
              body: JSON.stringify(loanPrefs)
            }).then(function (res) {
              return res.json();
            }).then(function (data) {
              if (data) {
                _this.setState({
                  loading: false,
                  confirmFinal: true,
                  notchanged: true
                });
              }
            });
            _this.props.trackerDispatcher(UserLanguage_ENUM.English, TrackerCategoryLID_ENUM.Button, TrackerHitTypeLID_ENUM.Event, TrackerActionLID_ENUM.Click, "Paperless Preference Change Button Clicked", 253);
          }
        },
        style: styles.accountSettings.button
      }, translations.Change)))));
    });
  };
  return PaperlessPreferences;
}(React.Component);
var mapStateToProps = function (state) {
  return {
    layout: state,
    translations: state.translations
  };
};
var mapDispatchToProps = function (dispatch) {
  return __assign({
    dispatch: dispatch
  }, bindActionCreators(Actions, dispatch));
};
export default connect(mapStateToProps, mapDispatchToProps)(PaperlessPreferences);